module.exports = __webpack_public_path__ + "static/media/power-atk5.aeb2f9ce.png";